import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Dot, Lock, Sizes } from "@/components/icon/IconList";
import { Chip } from "@bookips/solvook-ui-library";
import { Box, styled, Typography, useTheme } from "@mui/material";
import Image from "next/image";
function extractPlainTextFromRawEditorState(editorStateJSON) {
    try {
        const parsed = JSON.parse(editorStateJSON);
        return extractTextFromNode(parsed.root);
    } catch (e) {
        ;
        return "";
    }
}
function extractTextFromNode(node) {
    if (!node) return "";
    if (node.text) return node.text;
    if (Array.isArray(node.children)) {
        return node.children.map(extractTextFromNode).join(" ");
    }
    return "";
}
const BoardListItem = (props)=>{
    const theme = useTheme();
    const { title , contents , previewImageUrl , createdAt , newTag , status , isOwn , writerNickname , isPrivate , isBrandUser  } = props;
    const plainText = extractPlainTextFromRawEditorState(contents);
    const previewText = plainText.split("\n").slice(0, 3).join("\n");
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Box, {
            sx: {
                display: "flex",
                flexDirection: "column",
                gap: "16px"
            },
            children: [
                /*#__PURE__*/ _jsx(StatusChip, {
                    newTag: newTag,
                    status: status,
                    isOwn: isOwn,
                    isPrivate: isPrivate
                }),
                /*#__PURE__*/ _jsxs(ContentBox, {
                    children: [
                        /*#__PURE__*/ _jsxs(InfoBox, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(Box, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "12px"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "h6",
                                            sx: {
                                                wordBreak: "break-all"
                                            },
                                            children: title
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "body2",
                                            sx: {
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                [theme.breakpoints.down("sm")]: {
                                                    WebkitLineClamp: 1
                                                }
                                            },
                                            color: "text.secondary",
                                            children: previewText
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "caption",
                                    sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px"
                                    },
                                    color: "text.secondary",
                                    children: [
                                        writerNickname,
                                        /*#__PURE__*/ _jsx(Icon, {
                                            icon: Dot,
                                            size: Sizes.xxsmall,
                                            color: theme.palette.text.secondary
                                        }),
                                        createdAt
                                    ]
                                })
                            ]
                        }),
                        (isOwn || isBrandUser || !isPrivate) && previewImageUrl && /*#__PURE__*/ _jsx(ImageBox, {
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: previewImageUrl,
                                alt: "notice preview image",
                                fill: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
export const StatusChip = (param)=>{
    let { newTag , status , isOwn , isPrivate  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(StatusBox, {
        children: [
            newTag && /*#__PURE__*/ _jsx(Chip, {
                bold: true,
                label: "NEW",
                solvookColor: "red"
            }),
            status === "answered" && /*#__PURE__*/ _jsx(Chip, {
                bold: true,
                label: "답변완료",
                solvookColor: "mint"
            }),
            status === "waiting" && /*#__PURE__*/ _jsx(Chip, {
                bold: true,
                label: "답변대기",
                sx: (theme)=>({
                        color: theme.palette.text.secondary
                    })
            }),
            isOwn && /*#__PURE__*/ _jsx(Chip, {
                bold: true,
                label: "내 게시글",
                solvookColor: "indigo"
            }),
            isPrivate && /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px"
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: Lock,
                        size: Sizes.smallHalf,
                        color: theme.palette.text.secondary
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        color: "text.secondary",
                        children: "비공개 게시글"
                    })
                ]
            })
        ]
    });
};
const StatusBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        gap: theme.spacing(1)
    };
});
const ContentBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        gap: theme.spacing(4),
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
            gap: "20px"
        }
    };
});
const InfoBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.25)
    };
});
const ImageBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        position: "relative",
        width: "100px",
        height: "100px",
        borderRadius: theme.spacing(0.8),
        overflow: "hidden",
        border: "1px solid ".concat(theme.palette.opacity.gray300),
        flexShrink: 0,
        img: {
            objectFit: "cover"
        },
        [theme.breakpoints.down("sm")]: {
            width: "80px",
            height: "80px"
        }
    };
});
export default BoardListItem;
